// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"86ec13c8","320":"443fb4c8","662":"767f7f3d","692":"2f15c4a4","790":"c194849d","815":"2f15c4a4","843":"9d8621ff","887":"443fb4c8"}[chunkId] + ".chunk.css";
};